import { ReactNode } from "react";
import { css } from "styled-components";

export interface OverlayProps {
  isLoading?: boolean;
  spinnerMarginTop?: number;
  overlayOpacity?: number;
  hideContentWhileLoading?: boolean;
  backgroundColor?: string;
  wrap?: boolean;
  zIndex?: number;
  animate?: boolean;
  overlayContent?: ReactNode;
  rounded?: boolean;
}

export const overlayStyles = css<{
  $backgroundColor?: string;
  $zIndex?: number;
  $spinnerMarginTop?: number;
  $overlayOpacity?: number;
  $rounded?: boolean;
}>`
  height: 100%;
  width: 100%;
  border-radius: ${(p) => (p.$rounded === undefined || p.$rounded ? 8 : 0)}px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  background-color: inherit;
  ${(p) =>
    p.$backgroundColor &&
    `
    background-color: ${p.$backgroundColor} !important; 
  `};
  opacity: ${(p) => (p.theme.isDarkMode ? 0.85 : 0.7)};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  ${(props) =>
    props.$spinnerMarginTop &&
    `
    align-items: baseline;
    padding-top: ${props.$spinnerMarginTop}px;
  `}
  ${(props) =>
    props.$overlayOpacity &&
    `
    opacity: ${props.$overlayOpacity};
  `}
  ${(props) =>
    props.$zIndex &&
    `
    z-index: ${props.$zIndex};
  `}
`;
